import React, { FC } from "react";
import { TFunction } from 'i18next';
// import { DocumentFileSortableItem } from "./DocumentFileSortableItem";
import { DroppableListContainer } from "components/DroppableListContainer";
import { PartyItem } from "../ron-schedule-meeting/services";
import { PartyDroppableItem } from "./components/InvolvedPartyItem";

export type MoveActions = {
  kind: 'add' | 'remove';
  disabled: boolean;
  onAction: (partyId: string) => void;
  t: TFunction;
};

type Props = {
  title: string,
  involvedParties: PartyItem[];
  droppableContainerId: string,
  moveAction?: MoveActions,
  toolbar?: React.ReactNode
}

export const DroppableList: FC<Props> = ({
  title, involvedParties, droppableContainerId, moveAction, toolbar
}) => {
  return (
    <DroppableListContainer title={title} items={involvedParties} droppableContainerId={droppableContainerId} toolbar={toolbar}>
      {involvedParties.map(item => (
        <PartyDroppableItem
          key={item._id}
          party={item}
          moveAction={moveAction ? {
            disabled: moveAction.disabled,
            onClick: () => moveAction.onAction(item._id),
            icon: moveAction.kind === 'add' ? 'arrow-right' : 'arrow-left',
            ariaLabel: moveAction.t(
              moveAction.kind === 'add' ? 'ron:attendee-move-to-attendees-aria' : 'ron:attendee-move-to-parties-aria',
              { name: item.partyName, email: item.email }
            )
          } : undefined}
        />
      ))}
    </DroppableListContainer>
  );
};
